import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';

class FormComp08 extends Component{
    constructor(props){
        super(props);
        this.state = {
            fechaCorte: null,
            proveedor_sel: null,
            opcion: 'L',

            dataProveedor: [],
            coldefProveedor:[  
                                {
                                    header: "",
                                    width: 30,                    
                                    checkboxSelection: true,
                                    suppressSorting: true,
                                    suppressMenu: true,
                                    suppressFilter: true,
                                    pinned: true
                                },                
                                {   header: "N°",
                                    field: "Secuencia",
                                    width: 30,
                                    type: "string"
                                },
                                {   header: "Proveedor",
                                    field: "Proveedor",
                                    width: 360,
                                    type: "string"
                                },
                                {   header: "Compra",
                                    field: "Compra",
                                    width: 80,
                                    type: "string"
                                },
                                {   header: "Fecha",
                                    field: "Fecha",
                                    width: 70,
                                    type: "fecha"
                                },
                                { header: "Tipo",
                                    field: "Tipo",
                                    width: 60,
                                    type: "string"
                                },
                                { header: "N° Doc.",
                                    field: "numDoc",
                                    width: 110,
                                    type: "string"
                                },
                                { header: "Importe",
                                    field: "Importe",
                                    width: 80,
                                    type: "num_decimal"
                                },
                                { header: "Saldo",
                                    field: "Saldo",
                                    width: 80,
                                    type: "num_decimal"
                                },
                            ],
        };

        //GridOptions
        this.docsPorPagarProv = {
            context: {
                componentParent: this
            },
            rowSelection: "multiple",
            enableSorting: true,
            suppressRowClickSelection:true,
            singleClickEdit: false,
            enableColResize: true,
            enableCellChangeFlash: true,
            enableFilter: true, 
            onRowSelected: ((event)=>{}),
            onRowDataChanged:((event)=>{})
        };

        this.onGridDataProveedorReady = this.onGridDataProveedorReady.bind(this);
        this.changeComponents = this.changeComponents.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.impCarteraporPagarProveedoresLocales = this.impCarteraporPagarProveedoresLocales.bind(this);
    }

    onGridDataProveedorReady(params){
        this.apiGridDataProveedor = params.api;
        this.columnApiDataProveedor = params.columnApi;
    }

    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});

        if(target.type ==='radio' && name==='opcion' && value==='S'){
            //CARGA DE COMPRAS A FECHA DE CORTE
            let fechaCorte = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaCorte)
            this.cargarObjetos(`/pagoproveedores?fechacorte=${fechaCorte}`).then((result)=>{
                if(result.length > 0){
                    let arrayProveedor = [];
                    result.forEach((DATA, i)=>{
                        let item = {};

                        item.Secuencia = i + 1;
                        item.Proveedor = DATA.Nombre;
                        item.CodProveedor = DATA.Proveedor;
                        item.Compra = DATA.Compra;
                        item.Fecha = DATA.Fecha;
                        item.Tipo = DATA.Tipo;
                        item.numDoc = DATA.Factura;
                        item.Importe = DATA.Valor;
                        item.Saldo = DATA.saldo;

                        arrayProveedor.push(item);
                    })

                    this.setState({dataProveedor: arrayProveedor})
                }else{
                    alert('No existe data a presentar')
                }
            })
        }
    }

    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject('Error al cargar: ', err);
            });
        });
    }

    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    componentDidMount(){
        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('0608')
         ])
        .then(() => {
            //Asignacion de Fecha
            let fechaProceso = getFechaProcesoPorModulo('06')
            let fechaCorte = moment(fechaProceso, 'DD/MM/YYYY');
            this.setState({fechaCorte: fechaCorte})
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0608');
    }

    limpiar(){
        //Asignacion de Fecha
        let fechaProceso = getFechaProcesoPorModulo('06')

        let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta,
        proveedor_sel: null})
    }

    impCarteraporPagarProveedoresLocales(){
        

        switch (this.state.opcion) {
            case 'L':
                var parametros = ""
                parametros = '&rpt=15&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaCorte)
                if(this.state.proveedor_sel!==null){
                    parametros=parametros+'&param2='+this.state.proveedor_sel.value
                }

                parametros=parametros+'&param3='+this.state.opcion

                visualizarReporteEnPdf(parametros);                
                break;
            case 'S':
                let data = {};
                data.SeleccionProveedor = this.apiGridDataProveedor.getSelectedRows();

                this.props.cambiar_VisualizacionLoading(true);
                global_axios({
                    method: 'POST',
                    url: '/pagoproveedores',
                    data
                })
                .then((response)=>{
                    this.props.cambiar_VisualizacionLoading(false);

                    var parametros = ""
                    parametros = '&rpt=15&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaCorte)
                    parametros=parametros+'&param3='+this.state.opcion
                    visualizarReporteEnPdf(parametros);   
                })
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert("Ha ocurrido un error: "+error);
                });
                break;
            default:
                break;
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={70}>
            <HeaderForm>
                <TituloForm>Cartera por Pagar a Proveedores Locales</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'>  
                            <ContainerCol className='col-sm-2' margen_abajo='4' margen_arriba="15">
                                <LabelForm>Opciones:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-5 ' margen_abajo='4' margen_arriba="15">
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="opcion" value="L" checked={this.state.opcion==="L"} onChange={this.changeComponents} />
                                    Lista
                                </LabelForm>
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="opcion" value="S" checked={this.state.opcion==="S"} onChange={this.changeComponents} />
                                    Selección
                                </LabelForm>
                            </ContainerCol> 
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'>  
                            <ContainerCol className='col-sm-2' margen_abajo='4' margen_arriba="15">
                                <LabelForm>Fecha Corte:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-5 ' margen_abajo='4' margen_arriba="15">
                                <PickerFecha fechaSeleccionada={this.state.fechaCorte} func_onChange={(fechaEscogida)=>{this.setState({fechaCorte: fechaEscogida});}}/>
                            </ContainerCol> 
                        </ContainerCol>
                    </Row>
                    <Row  isInvisible={this.state.opcion==="S"?true:false}>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'>
                            <ContainerCol className='col-sm-2' margen_abajo='4'>
                                <LabelForm>Prov.:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-9' margen_abajo='4'>
                                <ReactSelectAsync value={this.state.proveedor_sel} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{this.setState({proveedor_sel: value!==null?value:null})}}/>
                            </ContainerCol>
                        </ContainerCol>
                    </Row>
                    <Row isInvisible={this.state.opcion==="S"?false:true}>
                        <ContainerCol className='col-sm-12'>
                            <AgGridRender altura='350px' data={this.state.dataProveedor} columnas={this.state.coldefProveedor}
                            gridOptions={this.docsPorPagarProv} onGridReady={this.onGridDataProveedorReady}/>
                        </ContainerCol>                        
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.fechaCorte===null?true:false} onClick={()=>{this.impCarteraporPagarProveedoresLocales()}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,}
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormComp08);